import React, { useContext, useEffect } from "react";

import { Button } from "@/components/Form";
import Sharing, { SharingType } from "@/components/Sharing";
import LocaleContext from "@/i18n";

import {
  ButtonWrap,
  ContentBox,
  Image,
  Section,
  SharingWrap,
  Text,
  Title,
  Wrapper,
} from "./styles";

export type ScoreProps = {
  range?: string;
  text?: string;
  image?: string;
  icons: IIcons;
  handleShareClick: (type: SharingType) => void;
  showRetry?: boolean;
  onRetry?: () => void;
  onLoad: () => void;
};

const Score: React.FC<ScoreProps> = (props: ScoreProps): React.JSX.Element => {
  const localeContext = useContext(LocaleContext);
  const { translation } = localeContext;

  useEffect(() => {
    setTimeout(() => props.onLoad(), 4000);
  }, []);

  return (
    <Section>
      <Wrapper>
        <ContentBox>
          <Title>
            {props.range} {translation.score.title}
          </Title>
          <Text>{props.text}</Text>
          {props.image && (
            <Image src={props.image} $showOnlyImage={!props.text} />
          )}
          {props.showRetry && (
            <ButtonWrap>
              <Button data-qa="score:retry:btn" onClick={props.onRetry}>
                {translation.score.retry}
              </Button>
            </ButtonWrap>
          )}
          <SharingWrap>
            <Sharing onShareClick={props.handleShareClick} />
          </SharingWrap>
        </ContentBox>
      </Wrapper>
    </Section>
  );
};

export default Score;
export { Score };
